export default "__VITE_ASSET__BG76srqr__"